
<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model.lazy="payment.total_value"
          v-currency="currency"
          label="Valor a usar do bônus"
          prefix="R$"
          prepend-inner-icon="mdi-gift-outline"
          :disabled="!client_id"
          :hint="!client_id ? 'Selecione o cliente primeiro' : `Disponível: ${formatMoney(client_bonus)}`"
          persistent-hint
          :rules="[...required, ...not_zero, ...positive_number, bonus_rule]"
          outlined
          dense
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {CurrencyDirective} from 'vue-currency-input'
import validations from '@/mixins/validations'

export default {
  name: 'WithBonus',
  mixins: [ validations ],
  directives: {
    currency: CurrencyDirective,
  },
  props: {
    payment: {
      type: Object,
    },
    client_bonus: {
      type: [String, Number],
    },
    client_id: {
      type: [String, Number],
    },
  },
  data() {
    return {
      bonus_rule: (v) => Number(String(v || '0').replace(/,/g, '')) <= Number(this.client_bonus) || 'Valor maior que bônus disponível',
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
    }
  },
  methods: {
    formatMoney(value) {
      return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
  },
  watch:{
    client_id(){
      this.payment.total_value = '0.00'
    }
  }
}
</script>
